import { postData } from './http';

const url: string = '/api2/flightsnew/static';

export function getFlightDurations(departureAirportGroups: TR.CsvString[],
    destinationAirportGroups: TR.CsvString[]): Promise<TR.FlightDurationResponse[]> {
    const request = {
        DepartureAirportGroups: departureAirportGroups,
        DestinationAirportGroups: destinationAirportGroups,
    };
    return postData<any>(url + '/getflightdurations', request)
        .then(data => data.GroupDurations);
}
